// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__MPRdN"};